module.exports = {
	"contract_name": "EthCapsule",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "min",
					"type": "uint256"
				}
			],
			"name": "setMinDuration",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalBuriedValue",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "capsuleNum",
					"type": "uint256"
				}
			],
			"name": "getCapsuleInfo",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalBuriedCapsules",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getNumberOfCapsules",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "capsuleNumber",
					"type": "uint256"
				}
			],
			"name": "dig",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "minDeposit",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "minDuration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "maxDuration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "min",
					"type": "uint256"
				}
			],
			"name": "setMinDeposit",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "unlockTime",
					"type": "uint256"
				}
			],
			"name": "bury",
			"outputs": [],
			"payable": true,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalCapsules",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "max",
					"type": "uint256"
				}
			],
			"name": "setMaxDuration",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalValue",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"type": "function"
		}
	],
	"unlinked_binary": "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",
	"networks": {
		"1": {
			"events": {},
			"links": {},
			"address": "0x5274a2293DBE075a82D41E873Bb927403a9dCE46",
			"updated_at": 1505288212876
		},
		"42": {
			"events": {},
			"links": {},
			"address": "0x37e4ef31178bcabaeefb97b43faf815f60da364e",
			"updated_at": 1505288212876
		}
	},
	"schema_version": "0.0.5",
	"updated_at": 1505288212876
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/EthCapsule.json
// module id = 539
// module chunks = 0